import featureFlags from 'shared/lib/featureFlags';


export default (title, args) => {
  if (!featureFlags.logger) {
    return;
  }

  const titleArgs = [`%c ENVs: ${title}`, 'color: green'];
  console.group(...titleArgs);
  console.log(args);
  console.groupEnd(...titleArgs);
};
